import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class TagSnapshot extends AbstractTagClass {
    #casting = false;
    constructor(argument) {
        super({
            ...argument,
            name: 'TagSnapshot'
        });
    }
    get autoplay() {
        return this?.tag.controller?.playerManager?.autoplay;
    }
    get player() {
        return this?.tag?.controller?.playerManager?.player;
    }
    get playerState() {
        return this?.tag?.controller?.playerManager?.player?.playbackState;
    }
    get contentType() {
        return this?.tag?.controller?.playerManager?.contentType;
    }
    get casting() {
        return this.#casting;
    }
    set casting(value) {
        this.#casting = value;
    }
}
